import { apiClient, withTagsParam } from '@/plugins/api'
import { Perm } from '@/common/constants'

export default {
  getRoles(accountId, companyId) {
    return apiClient.get(`admin/company/${companyId}/account/${accountId}/roles`)
  },
  updateAccountRoles(companyId, accountId, payload){
    return apiClient.put(`admin/company/${companyId}/account/${accountId}/assign-company`, payload)
  },
  getSingleAccount(accountId, companyId) {
    return apiClient.get(`admin/company/${companyId}/account/${accountId}`)
  },
  createAccount(companyId, payload) {
    return apiClient.post(`admin/company/${companyId}/account`, payload)
  },
  updateAccount(accountId, companyId, payload) {
    return apiClient.put(`admin/company/${companyId}/account/${accountId}`, payload)
  },
  updateProfileAccount(accountId, companyId, payload) {
    return apiClient.put(`admin/company/${companyId}/account/${accountId}/profile`, payload)
  },
  deleteAccount(companyId, accountId) {
    return apiClient.delete(`admin/company/${companyId}/account/${accountId}`)
  },
  importAccounts(companyId, payload) {
    let opt = {
      headers: {
        'Content-Type': 'multipart/form-data;'
      }
    }
    return apiClient.post(`admin/company/${companyId}/account/bulk`, payload, opt)
  },
  deleteAccountByUsername(companyId, username) {
    return apiClient.delete(`admin/company/${companyId}/account?username=${username}`)
  },
  getApprovers(companyId) {
    let opt = {
      params: { permissions: Perm.campaign.approve }
    }
    return apiClient.get(`admin/company/${companyId}/accounts-with-permission`, opt); 
  },
  exportAccounts(companyId, includeDeleted = false) {
    let opt = {
      responseType: 'blob',
      params: { includeDeleted }
    }
    return apiClient.get(`admin/company/${companyId}/export-account`, opt)

  },
  getAccounts(companyId, searchText, status, page, itemsPerPage, sortKey, sortDir) {
    const opt = {
      params: {
        search: searchText,
        status: status,
        _page: page,
        _limit: itemsPerPage,
        sortKey: sortKey,
        sortDir: sortDir
      }
    }
    return apiClient.get(`admin/company/${companyId}/account`, opt)
  },
  // Possible parameters to include as options:
  // - search: search text
  // - companyId: ID of the selected company
  // - tags: filters based on organization tags
  // - _page: current page number
  // - _limit: number of items per page
  // - sortKey: key for sorting
  // - sortDir: sorting direction (asc or desc)
  // - role_name: string default empty, it will filter some specific admin roles
  // - paginate: boolean default true (by backend), it allows paginating the result
  getAllAccounts(options) {
    const opts = { params: options }
    return apiClient.get(`admin/account`, withTagsParam(opts))
  },
  getTeamAccounts(companyId, teamName, paginate = false) {
    return apiClient.get(`admin/company/${companyId}/account?team=${teamName}&paginate=${paginate}`)
  },
  changePassword(uuid, companyId, payload) {
    return apiClient.put(`admin/company/${companyId}/account/${uuid}/change-password`, payload)
  },
  sendPassword(accountUUID, companyId) {
    return apiClient.post(`admin/company/${companyId}/account/${accountUUID}/send-password`)
  },
  getLastUnreadNotification(accountUUID, companyId) {
    return apiClient.get(`notification/company/${companyId}/account/${accountUUID}/notification/last`)
  },
  getNotifications(accountUUID, companyId, lang_code) {
    const opts = {
      params: {
        lang_code
      }
    }
    return apiClient.get(`notification/company/${companyId}/account/${accountUUID}/notification`, opts)
  },
  updateNotification(accountUUID, companyId, notificationId, payload) {
    return apiClient.put(`notification/company/${companyId}/account/${accountUUID}/notification/${notificationId}`, payload)
  },
  logOut(companyName) {
    let kc_url = '?rd=' + process.env.VUE_APP_KEYCLOAK_URL
    return apiClient.get(`oauth2/sign_out${kc_url}/auth/realms/${companyName}/protocol/openid-connect/logout`)
  },
  sendWelcomeMail(accountUUID, companyId) {
    return apiClient.post(`notification/company/${companyId}/account/${accountUUID}/send-first-access`)
  },
  bulkSendWelcomeMail(companyId, orgs) {
    return apiClient.post(`notification/company/${companyId}/bulk-send-first-access`, { orgs })
  },
  downloadDemoAccounts(companyId, payload){
    return apiClient.post(`admin/company/${companyId}/demo-accounts`, payload)
  },
  getOnlineUsers() {
    return apiClient.get(`admin/company/online-users`)
  }
}
